var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagementOutlineBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.301,
    height: 32.189,
    viewBox: "0 0 32.301 32.189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11623",
    "data-name": "Group 11623",
    transform: "translate(0.245 0.189)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_17895",
    "data-name": "Rectangle 17895",
    width: 32,
    height: 32,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12625",
    "data-name": "Path 12625",
    d: "M28.864,18.566a11.977,11.977,0,0,0,.1-1.472,9.053,9.053,0,0,0-.116-1.472l3.28-2.491a.765.765,0,0,0,.194-.962L29.214,6.943a.8.8,0,0,0-.951-.34L24.4,8.113a11.454,11.454,0,0,0-2.62-1.472l-.582-4A.769.769,0,0,0,20.422,2h-6.21a.749.749,0,0,0-.757.642l-.582,4a11.76,11.76,0,0,0-2.62,1.472L6.39,6.6a.778.778,0,0,0-.951.34L2.334,12.17a.718.718,0,0,0,.194.962l3.28,2.491a8.648,8.648,0,0,0-.019,2.943l-3.28,2.491a.765.765,0,0,0-.194.962L5.42,27.245a.8.8,0,0,0,.951.34l3.862-1.509a11.454,11.454,0,0,0,2.62,1.472l.582,4a.783.783,0,0,0,.776.641h6.21a.735.735,0,0,0,.757-.641l.582-4a11.76,11.76,0,0,0,2.62-1.472l3.862,1.509a.778.778,0,0,0,.951-.34L32.3,22.019a.718.718,0,0,0-.194-.962l-3.241-2.491ZM17.317,22.755a5.76,5.76,0,0,1-5.822-5.66,5.825,5.825,0,0,1,11.644,0A5.76,5.76,0,0,1,17.317,22.755Z",
    transform: "translate(-1.411 -1.189)",
    fill: "none",
    stroke: "#2F64F5",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagementOutlineBlue);
export default __webpack_public_path__ + "static/media/management_outline_blue.b44e6b1681d9f35407d0df9ebadd5f22.svg";
export { ForwardRef as ReactComponent };